<div [ngClass]="['accessibility--inner--'+mainStyle.themeName, interlignage, police]">
  <div class="accessibility--title">
    <div class="accessibility--title--label" data-cy="panel-title">Paramètres d’accessibilité</div>
    <div class="accessibility--title--action"><mat-icon (click)="closeDialog()">close</mat-icon></div>
  </div>
  <form [formGroup]="accessibilityForm">
    <div class="accessibility--content">
      <div class="accessibility--content--line">
        <div class="accessibility--content--line--label" data-cy="contrastes-label">Contrastes</div>
        <div class="accessibility--content--line--inner">
          <mat-button-toggle-group  formControlName="theme" aria-label="thèmes" (change)="setTheme($event.value)">
            <mat-button-toggle data-cy="contraste-default-value" [value]="themesNames.theme3">{{getThemeName(themesNames.theme3)}}</mat-button-toggle>
            <mat-button-toggle data-cy="contraste-inverse-value" [value]="themesNames.inverse">{{getThemeName(themesNames.inverse)}}</mat-button-toggle>
            <mat-button-toggle data-cy="contraste-renforce-value" [value]="themesNames.renforce">{{getThemeName(themesNames.renforce)}}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <div class="accessibility--content--line">
        <div class="accessibility--content--line--label" data-cy="interlignage-label">Interlignage</div>
        <div class="accessibility--content--line--inner">
          <mat-button-toggle-group  formControlName="interlignage" aria-label="interlignage" (change)="setInterlignage($event.value)">
            <mat-button-toggle data-cy="interlignage-default-value" [value]="interlignages.default">Défaut</mat-button-toggle>
            <mat-button-toggle data-cy="interlignage-augmenter-value" [value]="interlignages.augmenter">Augmenter</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <div class="accessibility--content--line">
        <div class="accessibility--content--line--label" data-cy="police-label">Police (dyslexie)</div>
        <div class="accessibility--content--line--inner">
          <mat-button-toggle-group  formControlName="police" aria-label="police" (change)="setPolice($event.value)">
            <mat-button-toggle data-cy="police-default-value" [value]="policeNames.default">Défaut</mat-button-toggle>
            <mat-button-toggle data-cy="police-adapter-value" [value]="policeNames.dyslexie">Adapter</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    </div>
  </form>
</div>
